import * as yup from 'yup'

const schema = yup.object().shape({
  reason: yup.string().required(),
})

export default schema
